let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080';
} else if (hostname === 'order.jug.thewebpeople.ca') {
    backendHost = 'https://order.jug.thewebpeople.ca';
} else {
    backendHost = 'https://order.jug.ca';
}

export const API_ROOT = `${backendHost}/api`;